import { ACTIVATED_PLUGIN_DATA, PLUGIN_BILLING_POP_UP, PLUGIN_NAME } from "../config/actionTypes";

const initialState = {
    isBilling: false,
    pluginData: {},
    activatedPlugin: [],
}
const PluginReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case PLUGIN_BILLING_POP_UP:
            return { ...state, isBilling: payload };
        case PLUGIN_NAME:
            return { ...state, pluginData: payload };
        case ACTIVATED_PLUGIN_DATA:
            return { ...state, activatedPlugin: payload };
        default:
            return state;
    }
}

export default PluginReducer;